// AlpineJS
import "alpine-magic-helpers";
import "alpinejs";

import Swiper from "swiper/bundle";
import Litepicker from "litepicker";
import "litepicker/dist/plugins/mobilefriendly";
import AOS from "aos";
import "lazysizes";

AOS.init({
  offset: 120,
  duration: 700,
  once: true,
});

function initializeSwiper() {
  var swiper = new Swiper(".swiper-container", {
    slidesPerView: 1.1,
    centeredSlides: true,
    spaceBetween: 10,
    allowTouchMove: true,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: false,
      },
    },
  });

  var swiper = new Swiper(".swiper-content", {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 10,
    allowTouchMove: true,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next2",
      prevEl: ".swiper-button-prev2",
    },
    breakpoints: {
      640: {
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: "auto",
      },
    },
  });

  var swiper = new Swiper(".swiper-webcamera", {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 10,
    allowTouchMove: true,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next2",
      prevEl: ".swiper-button-prev2",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 37,
        centeredSlides: false,
      },
    },
  });

  var OASwiper = new Swiper(".swiper-oa", {
    slidesPerView: 1.1,
    centeredSlides: false,
    spaceBetween: 10,
    allowTouchMove: true,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next2",
      prevEl: ".swiper-button-prev2",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 37,
        centeredSlides: false,
      },
    },
  });

  new Swiper(".swiper-instagram", {
    slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: 10,
    allowTouchMove: true,
  });

  if (window.screen.width < 1024) {
    var swiper = new Swiper(".swiper-banner", {
      //slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 0,
      allowTouchMove: true,
    });
  }
}

document.addEventListener("DOMContentLoaded", initializeSwiper);

var filterPicker;
createDateFilter();

htmx.on("htmx:afterSwap", function (event) {
  // console.log("reset images")
  // resetImages();
  updateDateFilter();
  initializeSwiper();
});

htmx.on("htmx:configRequest", function (evt) {
  var picker = document.getElementById("filterpicker");
  if (picker) {
    var from = picker.getAttribute("data-from");
    var to = picker.getAttribute("data-to");
    if (from && to) {
      evt.detail.parameters["time"] = from + "," + to;
      evt.detail.parameters["customTime"] = true;
    }
  }
});

function updateDateFilter() {
  if (filterPicker) {
    filterPicker.destroy();
  }
  createDateFilter();
}

if (window.screen.width < 1024) {
  htmx.on("htmx:afterSwap", function (event) {
    Alpine.start();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.src = image.dataset.src;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function (image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function () {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function (img) {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.src = img.dataset.src;
            img.classList.remove("lazy");
          }
        });
        if (lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});

function createDateFilter() {
  const litePickerElement = document.getElementById("filterpicker");
  if (litePickerElement) {
    var filterPicker = new Litepicker({
      element: litePickerElement,
      plugins: ["mobilefriendly"],
      mobilefriendly: {
        breakpoint: 1024,
      },
      singleMode: false,
      buttonText: {
        previousMonth:
          '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><g id="Group_1065" data-name="Group 1065" transform="translate(-1760 -493)"><g id="Ellipse_16" data-name="Ellipse 16" transform="translate(1810 543) rotate(180)" fill="#fff" stroke="#000000" stroke-width="1.5"><circle cx="25" cy="25" r="25" stroke="none"/><circle cx="25" cy="25" r="24.25" fill="none"/></g><text id="_" data-name="→" transform="translate(1796 538) rotate(180)" fill="#8f9db3" font-size="32" font-weight="300" font-family="Aeonik, sans-serif"><tspan x="0" y="30">→</tspan></text></g></svg>',
        nextMonth:
          '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><g id="Group_1064" data-name="Group 1064" transform="translate(-1815 -493)"><g id="Ellipse_15" data-name="Ellipse 15" transform="translate(1815 493)" fill="#fff" stroke="#000" stroke-width="1.5"><circle cx="25" cy="25" r="25" stroke="none"/><circle cx="25" cy="25" r="24.25" fill="none"/></g><text id="_" data-name="→" transform="translate(1829 496)" font-size="32" font-weight="300" font-family="Aeonik, sans-serif"><tspan x="0" y="30">→</tspan></text></g</svg>',
        reset: "<svg>...</svg>",
      },
      tooltipText: {
        one: window.location.href.indexOf("/en/") > -1 ? "day" : "dag",
        other: window.location.href.indexOf("/en/") > -1 ? "days" : "dager",
      },
      minDate: new Date(),
      lang: window.location.href.indexOf("/en/") > -1 ? "en" : "no",
      autoRefresh: true,
      setup: (picker) => {
        picker.on("selected", (date1, date2) => {
          var picker = document.getElementById("filterpicker");

          // Some modifications to filter the date properly
          const fromDateTimestamp = date1.dateInstance.getTime() / 1000;
          const updatedFromDateTimestamp = fromDateTimestamp + 3600;

          const toDateTimestamp = date2.dateInstance.getTime() / 1000;
          const updatedToDateTimestamp = toDateTimestamp + 3600;

          picker.classList.add("hidden");
          picker.setAttribute("data-from", updatedFromDateTimestamp);
          picker.setAttribute("data-to", updatedToDateTimestamp);

          htmx.trigger("#filter-component", "refresh");
        });
      },
    });
  }
}
